import { getBillingAccess, hasFullServiceAccess } from './billingAccess';

export { getBillingAccess } from './billingAccess';
export const hasSubscriptionAccess = (user, now = Date.now()) => user?.type === 'admin' || hasFullServiceAccess(user, now);
// Expiry removes publication and new intake, while approved owners retain existing work and billing.
export const hasAccountAccess = (user, now = Date.now()) => getBillingAccess(user, now).hasAccountAccess;
